module.exports = __webpack_public_path__ + "media/images/length_2-da55daa5d2be1c5e03b65991f2d1d30b.png";